import React, { useState } from "react";
import { Form, Input, Button, message, Spin, Row, Col, AutoComplete, Select, Typography, Divider, Upload } from "antd";
import { UserOutlined, HomeOutlined, BankOutlined, MailOutlined, LinkOutlined, NumberOutlined, UploadOutlined } from "@ant-design/icons";
import api from "../utils/api";

const { Title } = Typography;



const serviceData = [
  { id: 1, name: "Recruitment and Consultancy Service for Poland", unitNet: "600.00", vatRate: "0%", vatAmount: "0.00", totalGross: "600.00" },
  { id: 2, name: "Recruitment and Consultancy Service for Croatia", unitNet: "1,000.00", vatRate: "0%", vatAmount: "0.00", totalGross: "1,000.00" },
  { id: 3, name: "Recruitment and Consultancy Service for Czech Republic", unitNet: "800.00", vatRate: "0%", vatAmount: "0.00", totalGross: "800.00" },
  { id: 4, name: "Recruitment and Consultancy Service for Hungary", unitNet: "800.00", vatRate: "0%", vatAmount: "0.00", totalGross: "800.00" },
  { id: 5, name: "Recruitment and Consultancy Service for Lithuania", unitNet: "1,000.00", vatRate: "0%", vatAmount: "0.00", totalGross: "1,000.00" },
  { id: 6, name: "Recruitment and Consultancy Service for Romania", unitNet: "700.00", vatRate: "0%", vatAmount: "0.00", totalGross: "700.00" },
  { id: 7, name: "Recruitment and Consultancy Service for Serbia", unitNet: "800.00", vatRate: "0%", vatAmount: "0.00", totalGross: "800.00" },
  { id: 8, name: "Recruitment and Consultancy Service for Slovakia", unitNet: "800.00", vatRate: "0%", vatAmount: "0.00", totalGross: "800.00" },
  { id: 9, name: "Recruitment and Consultancy Service for Latvia", unitNet: "1,500.00", vatRate: "0%", vatAmount: "0.00", totalGross: "1,500.00" },
  { id: 10, name: "Recruitment and Consultancy Service for Estonia", unitNet: "700.00", vatRate: "0%", vatAmount: "0.00", totalGross: "700.00" }
];

const currencyData = [
  { id: 1, currency: "EUR", accountNo: "PL38109010140000000166176545"},
  { id: 2, currency: "PLN", accountNo: "PL81109010140000000166176450"},
  { id: 3, currency: "USD", accountNo: "PL07109010140000000166176618" }
];

export default function GeneratePdfForm({ onSuccess, closeParentModal }) {
  const [loading, setLoading] = useState(false);
  const [qrFile, setQrFile] = useState(null); 
  const [form] = Form.useForm();

  const serviceOptions = serviceData.map(service => ({ value: service.name }));
  const currencyOptions = currencyData.map(c => ({ value: c.currency, label: c.currency }));

  const onServiceChange = (value) => {
    const selectedService = serviceData.find(item => item.name === value);
    if (selectedService) {
      form.setFieldsValue({
        serviceName: selectedService.name,
        unitNet: selectedService.unitNet,
        vatRate: selectedService.vatRate,
        vatAmount: selectedService.vatAmount,
        totalGross: selectedService.totalGross
      });
    }
  };

  const onCurrencyChange = (value) => {
    const selectedCurrency = currencyData.find(item => item.currency === value);
    if (selectedCurrency) {
      form.setFieldsValue({
        currency: selectedCurrency.currency,
        accountNo: selectedCurrency.accountNo,
      });
    }
  };

  // Called by Ant Design Upload before the file is added to the list
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Only image files are allowed!");
      return Upload.LIST_IGNORE;          // reject the file, don't add to list
    }

    const isUnder1MB = file.size / 1024 / 1024 < 1;
    if (!isUnder1MB) {
      message.error("Image must be smaller than 1 MB!");
      return Upload.LIST_IGNORE;
    }

    setQrFile(file);                      // store the valid file in state
    return false;                         // prevent auto-upload (we handle it manually)
  };

  const onRemoveQr = () => {
    setQrFile(null);
  };

 const onFinish = async (values) => {
    setLoading(true);
    try {
      // Build a FormData payload so we can send the image alongside text fields
      const formData = new FormData();

      // Append all regular form fields
      Object.entries(values).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
          formData.append(key, val);
        }
      });

      // Append the QR image if one was selected
      if (qrFile) {
        formData.append("qrCode", qrFile);   // key name "qrCode" — adjust to match your backend
      }

      const response = await api.post("/crm/generatePdf", formData, {
        responseType: "blob",
        headers: {
          "Content-Type": "multipart/form-data",  // lets axios set the correct boundary automatically
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      message.success("PDF generated successfully!");
      if (closeParentModal) closeParentModal();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF");
    }
    setLoading(false);
  };


  return (
    <Spin spinning={loading}>
      <div style={{ padding: "24px" }}>
        <Title level={4} style={{ marginBottom: 20 }}>📄 Create New Invoice</Title>
        <Divider />
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Buyer Name" name="buyerName" rules={[{ required: true }]}>
                <Input prefix={<UserOutlined />} placeholder="Full Name" />
              </Form.Item>
              <Form.Item label="Buyer Email" name="buyerEmail" rules={[{ required: true, type: "email" }]}>
                <Input prefix={<MailOutlined />} placeholder="email@example.com" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Buyer Address" name="buyerAddress" rules={[{ required: true }]}>
                <Input.TextArea placeholder="Enter address" autoSize={{ minRows: 4, maxRows: 4 }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Currency" name="currency" rules={[{ required: true }]}>
                <Select placeholder="Select Currency" options={currencyOptions} onChange={onCurrencyChange} allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Account No." name="accountNo">
                <Input prefix={<BankOutlined />} disabled />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Service Name" name="serviceName" rules={[{ required: true }]}>
            <AutoComplete
              options={serviceOptions}
              onSelect={onServiceChange}
              placeholder="Select or type service"
              filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>

          <Row gutter={16}>
            <Col span={6}><Form.Item label="Unit Net" name="unitNet"><Input /></Form.Item></Col>
            <Col span={6}><Form.Item label="VAT Rate" name="vatRate"><Input /></Form.Item></Col>
            <Col span={6}><Form.Item label="VAT Amt" name="vatAmount"><Input /></Form.Item></Col>
            <Col span={6}><Form.Item label="Total Gross" name="totalGross"><Input /></Form.Item></Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Quantity" name="qty">
                <Input
                  prefix={<NumberOutlined />}
                  placeholder="1"
                  style={{ height: '40px' }}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Payment QR Code"
                extra="Upload a QR code image (max 1 MB)"
                style={{ marginBottom: 0 }}
              >
                <Upload
                  accept="image/*"
                  maxCount={1}
                  beforeUpload={beforeUpload}
                  onRemove={onRemoveQr}
                  listType="picture"
                  style={{ display: 'block', width: '100%' }}
                >
                  <Button
                    block                          // ← Ant Design's built-in full-width prop
                    icon={<UploadOutlined />}
                    style={{ height: '40px', marginTop: 0 }}
                    disabled={!!qrFile}
                  >
                    {qrFile ? "QR Code Selected" : "Click to Upload"}
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Divider />
          <Button type="primary" htmlType="submit" block size="large" style={{ height: 50, borderRadius: 8 }}>
            Generate & Open PDF
          </Button>
        </Form>
      </div>
    </Spin>
  );
}